import { render, staticRenderFns } from "./packageDetail.vue?vue&type=template&id=0be13ac6&scoped=true&"
import script from "./packageDetail.vue?vue&type=script&lang=js&"
export * from "./packageDetail.vue?vue&type=script&lang=js&"
import style0 from "./packageDetail.vue?vue&type=style&index=0&id=0be13ac6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be13ac6",
  null
  
)

export default component.exports